module.exports = __webpack_public_path__ + "static/media/ic-alert.b6b19446.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-alert.svg
// module id = 649
// module chunks = 0